import { Component, Input } from "@angular/core";
import { FiatWalletService } from "@main-services/wallet/fiat_wallet.service";
import { FiatTransaction } from "@models/transaction";
import { CustomModal } from "@modules/core/components/base-modals";

@Component({
	selector: "withdraw-pending",
	templateUrl: "./withdraw-pending.component.html",
	styleUrls: ["./../success-screen.component.scss"],
	standalone: false
})
export class WithdrawPendingComponent extends CustomModal {
	@Input()
	public transaction: FiatTransaction;

	public constructor(private fiatWalletService: FiatWalletService) {
		super();
	}

	public close(): void {
		this.modalService.pop();
	}

	public cancel(): void {
		this.fiatWalletService.cancel(this.transaction).then(() => this.close());
	}

	public resendEmail(): void {
		this.fiatWalletService.resendEmail(this.transaction);
	}
}
